import { schema } from "normalizr";
import { PermissionByRoleArraySchema } from "./permission-by-role";

const PermissionChildrenByRoleSchema = new schema.Entity("permissionChildrenByRoles", {
  permissions: PermissionByRoleArraySchema,
});
const PermissionChildrenByRoleArraySchema = new schema.Array(PermissionChildrenByRoleSchema);

export { PermissionChildrenByRoleSchema, PermissionChildrenByRoleArraySchema };